import { effects } from 'redux-saga'

import * as constants from '../../modules/signup/constants'

import handleView from './handleView'
import loadSignup from './loadSignup'

export default function* signup(apis) {
  yield [
    effects.takeEvery(constants.HANDLE_VIEW, handleView),
    effects.takeEvery(constants.LOAD_SIGNUP, loadSignup, apis),
  ]
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/signup/index.js